import { UrgencyInfo } from '../types/planning.types';

/**
 * Calculate urgency for an expertise based on dates
 */
export const calculateUrgency = (
  date: string | undefined,
  dateRv: string | undefined
): UrgencyInfo => {
  // Default non-urgent response
  const defaultUrgency: UrgencyInfo = {
    isUrgent: false,
    daysSince: 0,
    hoursSince: 0,
    totalHours: 0,
    referenceDate: null,
    reason: 'No urgency',
    urgencyLevel: 'normal',
    canBeUrgent: false
  };

  if (!date) return defaultUrgency;

  // If there's an appointment date, calculate days until
  if (dateRv) {
    const rvDate = new Date(dateRv);
    const now = new Date();
    const diffMs = rvDate.getTime() - now.getTime();
    const daysUntil = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    return {
      isUrgent: daysUntil <= 2 && daysUntil >= 0,
      daysSince: Math.abs(daysUntil),
      hoursSince: 0,
      totalHours: Math.abs(diffMs / (1000 * 60 * 60)),
      referenceDate: rvDate,
      reason: daysUntil < 0 ? 'Rendez-vous passé' : `${daysUntil} jours avant RV`,
      urgencyLevel: daysUntil <= 1 ? 'high' : daysUntil <= 3 ? 'medium' : 'normal',
      canBeUrgent: true
    };
  }

  // No appointment scheduled - calculate time since request
  const requestDate = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - requestDate.getTime();
  const daysSince = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const hoursSince = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const totalHours = Math.floor(diffMs / (1000 * 60 * 60));

  return {
    isUrgent: daysSince > 7,
    daysSince,
    hoursSince,
    totalHours,
    referenceDate: requestDate,
    reason: 'Pas de RV programmé',
    urgencyLevel: daysSince > 14 ? 'critical' : daysSince > 7 ? 'high' : 'normal',
    canBeUrgent: true
  };
};

/**
 * Calculate days until RV for display
 */
export const calculateDaysUntilRv = (dateRv: string | undefined): string => {
  if (!dateRv) return 'Non planifié';
  
  const rvDate = new Date(dateRv);
  const now = new Date();
  const days = Math.floor((rvDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  
  if (days < 0) return 'Passé';
  if (days === 0) return "Aujourd'hui";
  if (days === 1) return '1 jour';
  return `${days} jours`;
};